import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import UploadDropzoneProvider from "../../routes/sources/components/UploadDropzoneProvider";
import compareVersions, {
    VERSION_CM_15200_PROJECT_MULTI_ACCOUNT,
    VERSION_CM_6839_STORAGE_SYNC_STATUS_CHECK,
    VERSION_CM_9545_STORAGE_LOCK,
} from "../../cores/version";
import VersionedComponent from "../../components/VersionedComponent";
import StorageSyncTooltip from "@/components/tooltip/StorageSyncTooltip";
import { Tooltip, IconButton, Box, Typography, Grid, Collapse, Divider, InputAdornment, TextField } from "@mzc-pdc/ui";
import {
    IconArrowDownload,
    IconArrowUpload,
    IconHierarchyFolded,
    IconHierarchyOpened,
    ImageAssetOn,
    ImageBucketS3On,
    ImageCategoryGroupOn,
    ImageCateogrySmallOn,
    ImageCateogrySmallOff,
    ImageFolderSmallOn,
    ImageFolderSmallOff,
    ImageBucketS3Off,
    IconEmptyHierarchy,
    ImageCategoryGroupOff,
    ImageAssetOff,
    IconSetting,
    IconLock,
    IconChevronRight,
    IconChevronLeft,
    IconSearchCircle,
} from "@mzc-cloudplex/icons";
import LoadabledBucketLockSetting from "../bucket-lock-setting/bucket-lock-setting-popper";
import theme from "@styles/theme";
import { EllipsisTypography } from "@components_v2/ellipsis-tooltip";

class TreeView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            isFold: false,
            isSettingOpen: false,
        };
    }

    componentDidMount() {
        const { match } = this.props;

        if (match.path.indexOf("/cms") === 0) {
            this.setState({
                ...this.state,
                parentPath: "/cms",
                parentPathName: "CMS",
            });
        } else {
            this.setState({
                ...this.state,
                parentPath: "/contents",
                parentPathName: "Contents",
            });
        }
    }

    onClickTree(item) {
        // console.log("onClickTree");
        this.props.onClickTree(item);
    }

    onClickTreePath(item) {
        // console.log("onClickTreePath");
        this.props.onClickTreePath(item);
    }

    onChangeSearchValue = (search) => {
        const { searchData } = this.state;

        this.setState({
            ...this.state,
            search,
        });
    };

    onClickTreeFilter = () => {
        const { search } = this.state;
        this.props.onClickTreeFilter(search);
    };

    onClickResetTreeFilter = () => {
        this.props.onClickResetTreeFilter();

        this.setState({
            ...this.state,
            search: "",
        });
    };

    onHandleClickBucketLockSetting = () => {
        this.setState({
            ...this.state,
            isSettingOpen: !this.state.isSettingOpen,
        });
    };

    // onClickTreeChangeMenu(item) {
    //     this.props.onClickTreeChangeMenu(item);
    // }

    convertToStatus(item) {
        if (!item) return "";

        let result = [];
        if (item.isFold) {
            result.push("tree-open");
        }
        if (item.isSelected) {
            if (!item.isGroup) {
                result.push("tree-selected");
            }
        }
        if (item.isEmpty) {
            result.push("tree-empty");
        }

        return result.join(" ");
    }

    renderTreeNodeIcon(item, selected) {
        // console.log('tree', item)
        let result = "";
        const { bucketPath } = this.props;

        switch (item.type) {
            case "category":
                result = <ImageCateogrySmallOn width={16} height={16} />;
                break;

            case "categoryGroup":
                result = <ImageCategoryGroupOn width={16} height={16} />;
                break;

            case "folder":
                result = <ImageFolderSmallOn width={16} height={16} />;
                break;

            case "assets":
                result = <ImageAssetOn width={16} height={16} />;
                break;

            case "bucket":
                result = <ImageBucketS3On width={16} height={16} />;
                break;
        }

        if ((!item.isGroup && !item.isSelected) || (item.isGroup && !item.isActive)) {
            if ((bucketPath?.bucket !== item.name || item.type !== "bucket") && !selected) {
                switch (item.type) {
                    case "category":
                        result = <ImageCateogrySmallOff width={16} height={16} />;
                        break;

                    case "categoryGroup":
                        result = <ImageCategoryGroupOff width={16} height={16} />;
                        break;

                    case "folder":
                        result = <ImageFolderSmallOff width={16} height={16} />;
                        break;

                    case "assets":
                        result = <ImageAssetOff width={16} height={16} />;
                        break;

                    case "bucket":
                        result = <ImageBucketS3Off width={16} height={16} />;
                        break;
                }
            }
        }

        return result;
    }

    renderTreeNodeButton(item) {
        let result = "name";

        if (!item) return result;

        // if (item.isGroup && item.isActive) {
        //     result += " font-weight-bold";
        // }
        return result;
    }

    makeMultipleDiv(item) {
        if (!item?.code) {
            return "";
        }
        const makeArray = item.code.split("_") || [];
        if (makeArray.length < 1) {
            return "";
        }
        return makeArray.map((item, index) => {
            return <span key={index}></span>;
        });
    }

    renderTree(data, selected) {
        const { onDropTreeFile, onDropDisabled, fileUploadable, activeView, getBucketLockIcon } = this.props;
        const treeView =
            data &&
            data.length &&
            data.map((item) => {
                if (!item) return;
                let uploadDisabled = onDropDisabled ? onDropDisabled(item) : true;
                return (
                    <React.Fragment key={item.id}>
                        <ul>
                            <li
                                className={this.convertToStatus(item)}
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    e.dataTransfer.dropEffect = "move";
                                    e.target.style.color = "#2763ea";
                                    e.target.style.fontWeight = "bold";
                                }}
                                onDragLeave={(e) => {
                                    e.preventDefault();
                                    e.target.style.color = "";
                                    e.target.style.fontWeight = "";
                                }}
                                onDrop={(e) => {
                                    if (this.props.type !== "buckets") {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (this.props.onDropTreeItem) {
                                            this.props.onDropTreeItem(item);
                                        }
                                        e.target.style.color = "";
                                        e.target.style.fontWeight = "";
                                    }
                                }}
                            >
                                {fileUploadable ? (
                                    <UploadDropzoneProvider
                                        accept={"*"}
                                        onDrop={onDropTreeFile}
                                        disableClick={true}
                                        disabled={
                                            uploadDisabled ||
                                            (activeView === "Sources" && item.status && item.status !== "SYNCED")
                                        }
                                        target={item}
                                        stage={this.props.stage}
                                        createNewFolders={this.props.onCreateNewFolders}
                                    >
                                        <div className={`tree-item ${item.isSelected ? "tree-item-selected" : ""}`}>
                                            {item && this.makeMultipleDiv(item)}
                                            {item && item.hasOwnProperty("isFold") && (
                                                <button
                                                    type="button"
                                                    className={`btn btn-icon-solid btn-fold ${
                                                        item.isFold ? "active" : ""
                                                    }`}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        this.onClickTree(item);
                                                    }}
                                                    disabled={
                                                        activeView === "Sources" &&
                                                        item.status &&
                                                        item.status !== "SYNCED"
                                                    }
                                                >
                                                    {!item.isFold ? (
                                                        <IconHierarchyFolded size={12} htmlColor={`#6f6f83`} />
                                                    ) : (
                                                        <IconHierarchyOpened size={12} htmlColor={`#6f6f83`} />
                                                    )}
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                className={`${this.renderTreeNodeButton(item)}`}
                                                style={{ padding: "0 4px 0 0", marginRight: 0 }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    if (!this.props.pendingItem) this.onClickTreePath(item);
                                                }}
                                                disabled={
                                                    activeView === "Sources" && item.status && item.status !== "SYNCED"
                                                }
                                            >
                                                <Grid
                                                    container
                                                    width={"100%"}
                                                    flexWrap={"nowrap"}
                                                    alignItems={"center"}
                                                    sx={{
                                                        "& > span": {
                                                            maxWidth: "200px",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                        },
                                                    }}
                                                >
                                                    {/* <VersionedComponent version={VERSION_CM_4750_UPLOAD_FOLDERS}>
                                                    {item.type === "bucket" && uploadDisabled ? (
                                                        <span className="upload-status">
                                                            <i className="sprite sprite-upload-status-impossible"></i>
                                                        </span>
                                                    ) : item.type === "bucket" && !uploadDisabled ? (
                                                        <span className="upload-status">
                                                            <i className="sprite sprite-upload-status-possible"></i>
                                                        </span>
                                                    ) : (
                                                        ""
                                                    )}
                                                </VersionedComponent> */}

                                                    <VersionedComponent
                                                        version={VERSION_CM_6839_STORAGE_SYNC_STATUS_CHECK}
                                                    >
                                                        <StorageSyncTooltip
                                                            id={item.id}
                                                            indexingState={item.indexingState}
                                                            indexingRequestedAt={item.indexingRequestedAt}
                                                            indexingCompletedAt={item.indexingCompletedAt}
                                                        />
                                                    </VersionedComponent>

                                                    {/*<i className={`sprite sprite-${this.renderTreeNodeIcon(item)}`}> </i>*/}

                                                    {this.renderTreeNodeIcon(item, selected)}

                                                    {item.type === "bucket" && (
                                                        <Grid
                                                            container
                                                            flexDirection={"column"}
                                                            justifyContent={"center"}
                                                            width={"auto"}
                                                            gap={0.25}
                                                            mr={0.5}
                                                            sx={{ ".MzcCpIcon-root + *": { margin: 0 } }}
                                                        >
                                                            {item.uploadable ? (
                                                                <IconArrowUpload size={6} htmlColor={"#2763ea"} />
                                                            ) : (
                                                                <IconArrowUpload size={6} color={"disabled"} />
                                                            )}
                                                            {item.downloadable ? (
                                                                <IconArrowDownload size={6} htmlColor={"#2763ea"} />
                                                            ) : (
                                                                <IconArrowDownload size={6} color={"disabled"} />
                                                            )}
                                                        </Grid>
                                                    )}
                                                    <Typography sx={{ flex: 1 }} title={item.name}>
                                                        {item.name}
                                                    </Typography>

                                                    <div>{item.type === "bucket" && getBucketLockIcon(item)}</div>
                                                </Grid>
                                            </button>
                                        </div>
                                    </UploadDropzoneProvider>
                                ) : (
                                    <div className={"tree-item"}>
                                        {item && this.makeMultipleDiv(item)}
                                        {item && item.hasOwnProperty("isFold") && (
                                            <button
                                                type="button"
                                                className={`btn btn-icon-solid btn-fold ${item.isFold ? "active" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.onClickTree(item);
                                                }}
                                                disabled={
                                                    activeView === "Sources" && item.status && item.status !== "SYNCED"
                                                }
                                            >
                                                {!item.isFold ? (
                                                    <IconHierarchyFolded size={12} htmlColor={`#6f6f83`} />
                                                ) : (
                                                    <IconHierarchyOpened size={12} htmlColor={`#6f6f83`} />
                                                )}
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className={`${this.renderTreeNodeButton(item)}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (!this.props.pendingItem) this.onClickTreePath(item);
                                            }}
                                            disabled={
                                                activeView === "Sources" && item.status && item.status !== "SYNCED"
                                            }
                                            style={{ marginRight: 0 }}
                                        >
                                            <StorageSyncTooltip
                                                indexingState={item.indexingState}
                                                indexingRequestedAt={item.indexingRequestedAt}
                                                indexingCompletedAt={item.indexingCompletedAt}
                                            />
                                            {this.renderTreeNodeIcon(item, selected)}
                                            {item.type === "bucket" && (
                                                <Grid
                                                    container
                                                    flexDirection={"column"}
                                                    justifyContent={"center"}
                                                    width={"auto"}
                                                    gap={0.25}
                                                    mr={0.5}
                                                    sx={{ ".MzcCpIcon-root + *": { margin: 0 } }}
                                                >
                                                    {item.uploadable ? (
                                                        <IconArrowUpload size={6} htmlColor={"#2763ea"} />
                                                    ) : (
                                                        <IconArrowUpload size={6} color={"disabled"} />
                                                    )}
                                                    {item.downloadable ? (
                                                        <IconArrowDownload size={6} htmlColor={"#2763ea"} />
                                                    ) : (
                                                        <IconArrowDownload size={6} color={"disabled"} />
                                                    )}
                                                </Grid>
                                            )}
                                            <Typography sx={{ flex: 1 }} title={item.name}>
                                                {item.name}
                                            </Typography>
                                        </button>
                                    </div>
                                )}
                                {item.isFold === true && (item.children || []).length > 0
                                    ? this.renderTree(item.children, selected ? selected : item.isSelected)
                                    : ""}
                            </li>
                        </ul>
                    </React.Fragment>
                );
            });
        return treeView;
    }

    render() {
        const { t, treeData, type, searchData, hasSearch, isToggle, anchorRef, isShowBucketLockSetting } = this.props;

        const { search, isFold } = this.state;

        // console.log(anchorRef);
        return (
            <>
                <Box
                    sx={{
                        padding: `0 24px 0 0`,
                        maxWidth: "342px",
                        position: `relative`,
                        height: `100%`,
                        backgroundColor: theme.palette.common.white,
                        [theme.breakpoints.down("lg")]: {
                            position: `absolute`,
                            zIndex: theme.zIndex.drawer,
                        },
                    }}
                >
                    <Collapse
                        orientation="horizontal"
                        in={!isFold}
                        collapsedSize={40}
                        sx={{
                            "&": {
                                height: `100%`,
                                opacity: 0,
                                ".tree-view": {
                                    width: `auto`,
                                },
                            },
                            "&.MuiCollapse-entered": {
                                opacity: 1,
                                ".tree-view": {
                                    width: 318,
                                },
                            },
                            ".MuiCollapse-wrapper, .MuiCollapse-wrapperInner": {
                                width: `100%`,
                                height: `100%`,
                            },
                        }}
                    >
                        <Grid container flexDirection={"column"} sx={{ height: `100%` }}>
                            {isShowBucketLockSetting && (
                                <>
                                    {compareVersions(this.props.stage.version, VERSION_CM_9545_STORAGE_LOCK) >= 0 &&
                                        compareVersions(
                                            this.props.stage.version,
                                            VERSION_CM_15200_PROJECT_MULTI_ACCOUNT,
                                        ) < 0 && (
                                            <Grid item>
                                                <Box sx={{ margin: "21px 0" }}>
                                                    {this.state.isSettingOpen && (
                                                        <LoadabledBucketLockSetting
                                                            anchorRef={anchorRef.current}
                                                            open={this.state.isSettingOpen}
                                                            onHandleClickClose={this.onHandleClickBucketLockSetting}
                                                            onChangeBucketLock={this.props.onChangeBucketLock}
                                                            getBucketLockIcon={this.props.getBucketLockIcon}
                                                        />
                                                    )}
                                                    <Grid
                                                        container
                                                        alignItems={"center"}
                                                        flexWrap={"nowrap"}
                                                        sx={{
                                                            width: "100%",
                                                            height: 40,
                                                            backgroundColor: "#f2f3f6",
                                                            // margin: "21px 21px 18px 21px",
                                                            borderRadius: "6px",
                                                            px: `11px`,
                                                        }}
                                                    >
                                                        <Box
                                                            sx={{
                                                                display: `inline-flex`,
                                                                alignItems: `center`,
                                                                justifyContent: `center`,
                                                                borderRadius: `100%`,
                                                                width: `18px`,
                                                                height: `18px`,
                                                                mr: `6px`,
                                                                backgroundColor: theme.palette.warning.main,
                                                            }}
                                                        >
                                                            <IconLock size={10} htmlColor={"#fff"} />
                                                        </Box>
                                                        <EllipsisTypography
                                                            flex={1}
                                                            color={"#000"}
                                                            component={`p`}
                                                            noWrap
                                                            sx={{ opacity: 1, fontSize: "14px", fontWeight: "bold" }}
                                                        >
                                                            {t(`common::label::Set lockout for other users`)}
                                                        </EllipsisTypography>
                                                        <Tooltip title={t(`common::label::Settings`, `Settings`)}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    this.onHandleClickBucketLockSetting();
                                                                }}
                                                                size="small"
                                                                type="button"
                                                                variant="text"
                                                            >
                                                                <IconSetting size={16} color={`secondary`} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Box>
                                                <Divider flexItem />
                                            </Grid>
                                        )}
                                </>
                            )}
                            <Grid item>
                                {hasSearch && (
                                    <form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            this.onClickTreeFilter();
                                        }}
                                    >
                                        <TextField
                                            fullWidth
                                            color={"primary"}
                                            variant={"standard"}
                                            size={"medium"}
                                            onChange={(e) => {
                                                this.onChangeSearchValue(e.target.value);
                                            }}
                                            placeholder={t(`common::label::Search`)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Tooltip title={t(`common::label::Search`, `Search`)}>
                                                            <IconButton
                                                                circled
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    this.onClickTreeFilter();
                                                                }}
                                                            >
                                                                <IconSearchCircle size={20} color={"greySecondary"} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                sx: {
                                                    padding: `13.95px 12px`,
                                                },
                                            }}
                                        />
                                    </form>
                                )}
                            </Grid>
                            <Grid item xs sx={{ overflow: `auto`, paddingTop: 1 }}>
                                <Box
                                    className="tree-view"
                                    sx={{ "&& .tree-select > ul > li:after": { left: 0, right: 0 } }}
                                >
                                    <Box className="tree-select">
                                        {treeData.pending ? (
                                            <div className={"loading-block"}>
                                                <span className={"loading-content"} />
                                            </div>
                                        ) : searchData && searchData.isSearched ? (
                                            searchData.data && searchData.data.length ? (
                                                this.renderTree(searchData.data)
                                            ) : (
                                                <div className={"empty"}>
                                                    <IconEmptyHierarchy size={20} color={`#dfdfee`} />
                                                    <Typography variant={"body1"}>
                                                        {t(`common::label::No ${type} ${treeData.isActiveView || ""}`)}
                                                    </Typography>
                                                </div>
                                            )
                                        ) : treeData[treeData.isActiveView] &&
                                          treeData[treeData.isActiveView].data &&
                                          treeData[treeData.isActiveView].data.length ? (
                                            this.renderTree(treeData[treeData.isActiveView].data)
                                        ) : (
                                            <div className={"empty"}>
                                                <IconEmptyHierarchy size={20} color={`#dfdfee`} />
                                                <Typography variant={"body1"}>
                                                    {t(`common::label::No ${type} ${treeData.isActiveView || ""}`)}
                                                </Typography>
                                            </div>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Collapse>

                    <Box
                        isFold={isFold}
                        sx={{
                            position: `absolute`,
                            right: 0,
                            top: 0,
                            bottom: 0,
                            zIndex: 1,
                            display: `flex`,
                            alignItems: `center`,
                            width: 24,
                            "&:before,&:after": {
                                content: '""',
                                display: `block`,
                                position: `absolute`,
                                top: `0`,
                                bottom: `0`,
                                opacity: 0,
                                transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
                            },
                            "&:before": {
                                left: `100%`,
                                width: 24,
                                backgroundColor: theme.palette.common.white,
                            },
                            "&:after": {
                                left: `100%`,
                                width: 12,
                                boxShadow: `-5px 0 6px 0 rgba(0, 0, 0, 0.1)`,
                            },
                            "&:hover": {
                                "&:before,&:after": {
                                    opacity: 1,
                                },
                                button: {
                                    opacity: 1,
                                },
                            },
                            [theme.breakpoints.down("lg")]: {
                                "&:before,&:after": {
                                    opacity: 1,
                                },
                            },
                            ...(isFold === true && {
                                "&:before,&:after": {
                                    content: '""',
                                    display: `block`,
                                    position: `absolute`,
                                    top: `0`,
                                    bottom: `0`,
                                    transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
                                },
                                "&:before": {
                                    left: `0`,
                                    width: 13,
                                    backgroundColor: theme.palette.common.white,
                                },
                                "&:after": {
                                    left: `50%`,
                                    width: 12,
                                    boxShadow: `-5px 0 6px 0 rgba(0, 0, 0, 0.1)`,
                                },
                            }),
                            button: {
                                zIndex: `1`,
                                borderRadius: `100%`,
                                transition: `opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)`,
                                "&:hover": {
                                    boxShadow: `0 3px 3px 0 rgba(0, 0, 0, 0.12)`,
                                },
                                ...(isFold
                                    ? {
                                          opacity: 1,
                                      }
                                    : {
                                          opacity: 0,
                                          marginLeft: 1.25,
                                          backgroundColor: theme.palette.common.white,
                                          "&:hover, &:active, &:focus": {
                                              boxShadow: `0 3px 3px 0 rgba(0, 0, 0, 0.12)`,
                                              backgroundColor: theme.palette.common.white,
                                          },
                                          [theme.breakpoints.down("lg")]: {
                                              opacity: 1,
                                          },
                                      }),
                            },
                        }}
                    >
                        <Tooltip
                            title={isFold ? t(`common::label::Expand`, `Expand`) : t(`common::label::Fold`, `Fold`)}
                        >
                            <IconButton
                                circled
                                size={"small"}
                                onClick={() => {
                                    if (!this.state.isFold) {
                                        this.setState({
                                            ...this.state,
                                            isFold: !this.state.isFold,
                                            isSettingOpen: false,
                                        });
                                    } else {
                                        this.setState({
                                            ...this.state,
                                            isFold: !this.state.isFold,
                                        });
                                    }
                                }}
                                variant={isFold ? "contained" : "outlined"}
                                color={isFold ? "grey" : "secondary"}
                            >
                                {isFold ? <IconChevronRight size={12} /> : <IconChevronLeft size={12} />}
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                {/*<div className={`tree ${isToggle ? "toggle-active" : ""} ${isFold ? "tree-fold" : ""} `}>*/}
                {/*    <div className={"tree-inner"}>*/}
                {/*        <VersionedComponent version={VERSION_CM_9545_STORAGE_LOCK}>*/}
                {/*            {isShowBucketLockSetting && (*/}
                {/*                <div className={"tree-tool"}>*/}
                {/*                    <Box sx={{ margin: "20px 21px 18px 21px" }}>*/}
                {/*                        {this.state.isSettingOpen && (*/}
                {/*                            <LoadabledBucketLockSetting*/}
                {/*                                anchorRef={anchorRef.current}*/}
                {/*                                open={this.state.isSettingOpen}*/}
                {/*                                onHandleClickClose={this.onHandleClickBucketLockSetting}*/}
                {/*                                onChangeBucketLock={this.props.onChangeBucketLock}*/}
                {/*                                getBucketLockIcon={this.props.getBucketLockIcon}*/}
                {/*                            />*/}
                {/*                        )}*/}
                {/*                        <Grid*/}
                {/*                            container*/}
                {/*                            alignItems={"center"}*/}
                {/*                            flexWrap={"nowrap"}*/}
                {/*                            sx={{*/}
                {/*                                width: "100%",*/}
                {/*                                height: 40,*/}
                {/*                                backgroundColor: "#f2f3f6",*/}
                {/*                                // margin: "21px 21px 18px 21px",*/}
                {/*                                borderRadius: "6px",*/}
                {/*                                px: `11px`,*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            <Box*/}
                {/*                                sx={{*/}
                {/*                                    display: `inline-flex`,*/}
                {/*                                    alignItems: `center`,*/}
                {/*                                    justifyContent: `center`,*/}
                {/*                                    borderRadius: `100%`,*/}
                {/*                                    width: `18px`,*/}
                {/*                                    height: `18px`,*/}
                {/*                                    mr: `6px`,*/}
                {/*                                    backgroundColor: theme.palette.warning.main,*/}
                {/*                                }}*/}
                {/*                            >*/}
                {/*                                <IconLock size={10} htmlColor={"#fff"} />*/}
                {/*                            </Box>*/}
                {/*                            <Typography*/}
                {/*                                flex={1}*/}
                {/*                                color={"#000"}*/}
                {/*                                component={`p`}*/}
                {/*                                noWrap*/}
                {/*                                sx={{ opacity: 1, fontSize: "14px", fontWeight: "bold" }}*/}
                {/*                            >*/}
                {/*                                {t(`common::label::Set lockout for other users`)}*/}
                {/*                            </Typography>*/}
                {/*                            <IconButton*/}
                {/*                                onClick={() => {*/}
                {/*                                    this.onHandleClickBucketLockSetting();*/}
                {/*                                }}*/}
                {/*                                size="small"*/}
                {/*                                type="button"*/}
                {/*                                variant="text"*/}
                {/*                            >*/}
                {/*                                <IconSetting size={16} color={`secondary`} />*/}
                {/*                            </IconButton>*/}
                {/*                        </Grid>*/}
                {/*                    </Box>*/}

                {/*                    <hr />*/}
                {/*                </div>*/}
                {/*            )}*/}
                {/*        </VersionedComponent>*/}
                {/*        {hasSearch && (*/}
                {/*            <div*/}
                {/*                className={clsx(`tree-tool`, {*/}
                {/*                    "has-nav": treeData && treeData.menu && treeData.menu.length,*/}
                {/*                    "has-search": hasSearch,*/}
                {/*                })}*/}
                {/*            >*/}
                {/*                <form*/}
                {/*                    onSubmit={(e) => {*/}
                {/*                        e.preventDefault();*/}
                {/*                        this.onClickTreeFilter();*/}
                {/*                    }}*/}
                {/*                >*/}
                {/*                    <div className={"form-search form-search-compact"}>*/}
                {/*                        <div className={"search-form-group"}>*/}
                {/*                            <input*/}
                {/*                                onChange={(e) => {*/}
                {/*                                    this.onChangeSearchValue(e.target.value);*/}
                {/*                                }}*/}
                {/*                            >*/}
                {/*                                <IconCancelCircle size={16} />*/}
                {/*                            </input>*/}
                {/*                        </div>*/}
                {/*                        <button*/}
                {/*                            type="submit"*/}
                {/*                            className={"btn btn-icon btn-dark"}*/}
                {/*                            onClick={(e) => {*/}
                {/*                                e.preventDefault();*/}
                {/*                                this.onClickTreeFilter();*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            <IconSearch size={16} />*/}
                {/*                        </button>*/}
                {/*                    </div>*/}
                {/*                </form>*/}
                {/*            </div>*/}
                {/*        )}*/}
                {/*        <div className={"tree-sticky"}>*/}
                {/*            <div className={"tree-view"}>*/}
                {/*                <div className={"tree-select"}>*/}
                {/*                    {treeData.pending ? (*/}
                {/*                        <div className={"loading-block"}>*/}
                {/*                            <span className={"loading-content"} />*/}
                {/*                        </div>*/}
                {/*                    ) : searchData && searchData.isSearched ? (*/}
                {/*                        searchData.data && searchData.data.length ? (*/}
                {/*                            this.renderTree(searchData.data)*/}
                {/*                        ) : (*/}
                {/*                            <div className={"empty"}>*/}
                {/*                                <IconEmptyHierarchy size={20} color={`#dfdfee`} />*/}
                {/*                                <p>{t(`common::label::No ${type} ${treeData.isActiveView || ""}`)}</p>*/}
                {/*                            </div>*/}
                {/*                        )*/}
                {/*                    ) : treeData[treeData.isActiveView] &&*/}
                {/*                      treeData[treeData.isActiveView].data &&*/}
                {/*                      treeData[treeData.isActiveView].data.length ? (*/}
                {/*                        this.renderTree(treeData[treeData.isActiveView].data)*/}
                {/*                    ) : (*/}
                {/*                        <div className={"empty"}>*/}
                {/*                            <IconEmptyHierarchy size={20} color={`#dfdfee`} />*/}
                {/*                            <p>{t(`common::label::No ${type} ${treeData.isActiveView || ""}`)}</p>*/}
                {/*                        </div>*/}
                {/*                    )}*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}

                {/*        <button*/}
                {/*            type={"button"}*/}
                {/*            className={`btn-tree-fold ${isFold ? "fold" : ""}`}*/}
                {/*            onClick={() => {*/}
                {/*                if (!this.state.isFold) {*/}
                {/*                    this.setState({*/}
                {/*                        ...this.state,*/}
                {/*                        isFold: !this.state.isFold,*/}
                {/*                        isSettingOpen: false,*/}
                {/*                    });*/}
                {/*                } else {*/}
                {/*                    this.setState({*/}
                {/*                        ...this.state,*/}
                {/*                        isFold: !this.state.isFold,*/}
                {/*                    });*/}
                {/*                }*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            <span className={`btn btn-round btn-secondary`}>*/}
                {/*                {isFold ? (*/}
                {/*                    <IconArrowForward size={12} htmlColor={`#fff`} />*/}
                {/*                ) : (*/}
                {/*                    <IconArrowBack size={12} htmlColor={`#fff`} />*/}
                {/*                )}*/}
                {/*            </span>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </>
        );
    }
}

TreeView.propTypes = {
    searchData: PropTypes.object,
    treeData: PropTypes.object,
    type: PropTypes.string,
    hasSearch: PropTypes.bool,
    onDropTreeItem: PropTypes.func,
    onClickTree: PropTypes.func,
    onClickTreeFilter: PropTypes.func,
    onClickResetTreeFilter: PropTypes.func,
    onClickTreePath: PropTypes.func,
    onChangeBucketLock: PropTypes.func,
    isShowBucketLockSetting: PropTypes.bool,
    // onClickTreeChangeMenu: PropTypes.func
};

TreeView.defaultProps = {
    hasSearch: false,
    isShowBucketLockSetting: false,
};

export default withTranslation()(withRouter(TreeView));
